import { Link } from '@tanstack/react-router'
import { Button, EmptyState } from '@volee/ui'

import { messages } from '../messages/index.ts'
import { NAV_PATHS } from '../navigation/paths.ts'

/** The router's 404. Text from the message layer, like everything else. */
export function NotFound() {
  return (
    <EmptyState
      title={messages.notFound.title}
      description={messages.notFound.description}
      action={
        <Button asChild>
          <Link to={NAV_PATHS.home}>{messages.notFound.backToHome}</Link>
        </Button>
      }
    />
  )
}
